import React from 'react';
import { IMessengerContext } from './IMessengerContext';
const MessengerContext: React.Context<IMessengerContext> = React.createContext<IMessengerContext>({} as IMessengerContext);
export { MessengerContext }